/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Exercise_Sheet_Tabs_LabelInputs */

const en_us2_exercise_sheet_tabs_label = /** @type {(inputs: Exercise_Sheet_Tabs_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exercise sections`)
};

const pt_br2_exercise_sheet_tabs_label = /** @type {(inputs: Exercise_Sheet_Tabs_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seções do exercício`)
};

const es_419_exercise_sheet_tabs_label = /** @type {(inputs: Exercise_Sheet_Tabs_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Secciones del ejercicio`)
};

const pt_pt2_exercise_sheet_tabs_label = /** @type {(inputs: Exercise_Sheet_Tabs_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Secções do exercício`)
};

const fr_fr2_exercise_sheet_tabs_label = /** @type {(inputs: Exercise_Sheet_Tabs_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sections de l'exercice`)
};

const de_de2_exercise_sheet_tabs_label = /** @type {(inputs: Exercise_Sheet_Tabs_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bereiche der Übung`)
};

const it_it2_exercise_sheet_tabs_label = /** @type {(inputs: Exercise_Sheet_Tabs_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sezioni dell'esercizio`)
};

/**
* | output |
* | --- |
* | "Exercise sections" |
*
* @param {Exercise_Sheet_Tabs_LabelInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const exercise_sheet_tabs_label = /** @type {((inputs?: Exercise_Sheet_Tabs_LabelInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Exercise_Sheet_Tabs_LabelInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_exercise_sheet_tabs_label(inputs)
	if (locale === "es-419") return es_419_exercise_sheet_tabs_label(inputs)
	if (locale === "pt-PT") return pt_pt2_exercise_sheet_tabs_label(inputs)
	if (locale === "fr-FR") return fr_fr2_exercise_sheet_tabs_label(inputs)
	if (locale === "de-DE") return de_de2_exercise_sheet_tabs_label(inputs)
	if (locale === "it-IT") return it_it2_exercise_sheet_tabs_label(inputs)
	return en_us2_exercise_sheet_tabs_label(inputs)
});
export { exercise_sheet_tabs_label as "exercise-sheet.tabs_label" }